// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VVGp","content":"styles_content__3l70z"};